module.exports = __webpack_public_path__ + "img/solutionBanner3.ea78143e.png";